import React, { ReactElement } from 'react';
import { Col, Row } from 'idsk-react-components';
import { Message } from 'slovlex-idsk-react-components';
import { useErrorMessageContext } from '../../context/ErrorMessageContext';
import './errorMessages.scss';

export default (): ReactElement => {
  const { messages, clearMessages } = useErrorMessageContext();

  return messages && (
    <>
      { messages.map(message => (
        <Row key={message}>
          <Col>
            <Message
              className="error-message"
              type="error"
              onClear={clearMessages}
              headingSize="m"
            >
              {message}
            </Message>
          </Col>
        </Row>
      ))}
    </>
  );
};
